import { ConfigActions, ConfigActionTypes, FetchAppConfigSuccess, FetchAppInfoSuccess } from '@app/core/actions/config';
import { AppConfig } from '@app/core/models/app-config';
import { AppInfo } from '@app/core/models/app-info';
import { createHandler, createReducer } from '@app/util';
import * as R from 'ramda';

export interface State {
  appConfig: AppConfig;
  appInfo: AppInfo;
}

export const initialState: State = {
  appConfig: null,
  appInfo: null
};

export const getDocumentation = R.prop('documentation');
export const getMailPcsSupport = R.prop('mailPcsSupport');

const fetchAppConfigSuccessHandler = createHandler(
  ConfigActionTypes.FetchAppConfigSuccess,
  (state: State, action: FetchAppConfigSuccess) =>
    R.mergeRight(state, {
      appConfig: action.payload
    })
);

const fetchAppInfoSuccessHandler = createHandler(
  ConfigActionTypes.FetchAppInfoSuccess,
  (state: State, action: FetchAppInfoSuccess) =>
    R.mergeRight(state, {
      appInfo: action.payload
    })
);

export const reducer = createReducer<State, ConfigActions>([
  fetchAppConfigSuccessHandler,
  fetchAppInfoSuccessHandler
], initialState);

export const getAppConfig = (state: State) => state.appConfig;

export const getAppInfo = (state: State) => state.appInfo;
